import * as types from './types';
import defaultWidgetSettingsByType from './widgetSettingsByType';

const setCurrentDashboard = id => ({
  type: types.SET_CURRENT_DASHBOARD,
  payload: {
    id
  }
});

const dashboardAuthTokenReceived = token => ({
  type: types.DASHBOARD_AUTH_TOKEN_RECEIVED,
  payload: {
    token
  }
});

const updateWidgets = (widgets, pageIndex) => ({
  type: types.WIDGETS_UPDATED,
  payload: {
    widgets,
    pageIndex
  }
});

const updateWidget = (widgetId, fields) => ({
  type: types.WIDGET_UPDATED,
  payload: {
    widgetId,
    fields
  }
});

const updateWidgetSettings = (widgetId, fields) => ({
  type: types.WIDGET_SETTINGS_UPDATED,
  payload: {
    widgetId,
    fields
  }
});

const removeWidget = widgetId => ({
  type: types.WIDGET_REMOVED,
  payload: {
    widgetId
  }
});

const addWidget = (widget, pageIndex) => ({
  type: types.WIDGET_ADDED,
  payload: {
    pageIndex,
    // give the new widget a temporary unique ID
    widget: {
      ...widget,
      id: globalThis.crypto.randomUUID(),
      settings: defaultWidgetSettingsByType[widget.archetype_id] || {}
    }
  }
});

const setDashboardDateTime = dateTime => ({
  type: types.SET_DASHBOARD_DATETIME,
  payload: { dateTime }
});

const setDashboardMode = mode => ({
  type: types.SET_DASHBOARD_MODE,
  payload: { mode }
});

const unlockDashboardDatetime = () => ({
  type: types.UNLOCK_DASHBOARD_DATETIME
});

const activateIncidentMode = () => ({
  type: types.ACTIVATE_INCIDENT_MODE
});

const activateNormalMode = () => ({
  type: types.ACTIVATE_NORMAL_MODE
});

const setDisplayedIncidentId = (id, force = false) => ({
  type: types.UPDATE_DISPLAYED_INCIDENT_ID,
  payload: { id, force }
});

const setEditMode = editMode => ({
  type: types.UPDATE_EDIT_MODE,
  payload: { editMode }
});

const lockIncident = lockValue => ({
  type: types.LOCK_INCIDENT,
  payload: { lockValue }
});

export {
  setCurrentDashboard,
  dashboardAuthTokenReceived,
  updateWidgets,
  removeWidget,
  addWidget,
  setDashboardDateTime,
  setDashboardMode,
  unlockDashboardDatetime,
  activateIncidentMode,
  activateNormalMode,
  setDisplayedIncidentId,
  updateWidget,
  updateWidgetSettings,
  setEditMode,
  lockIncident
};
